import { appendUserMessage } from './appendUserMessage';
import { handleAjaxError } from './handleAjaxError';
import { renderMessage } from './renderMessage';
import { scrollToChatBottom } from './scrollToChatBottom';
import { updateCredits } from './updateCredits';
const {
    createGenerationRequestId,
    waitForAsyncTextGeneration,
} = require('../helpers/asyncTextGeneration.cjs');

function requestGenerationStatus(job) {
    return new Promise((resolve, reject) => {
        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            timeout: 15000,
            data: {
                action: growtype_chat_ajax.generation_job_status_action,
                job_id: job.id,
                job_token: job.token,
                nonce: growtype_chat_ajax.nonce,
            },
            success: resolve,
            error: reject,
        });
    });
}

function finishBranch(chatForm, discardedMessages, loader, response) {
    // The server has persisted the replacement and removed the superseded
    // branch. The detached DOM nodes are no longer needed either.
    discardedMessages.remove();

    return renderMessage(chatForm, response, loader).then(() => {
        const newMessageId = response.data.last_ai_message_id;
        if (newMessageId) {
            chatForm
                .find('.g-chatform-message[data-role="user"]')
                .last()
                .attr('data-id', newMessageId);
        }
        scrollToChatBottom(500, true);
    });
}

function submitBranch(action) {
    const messageElement = action.closest('.g-chatform-message');
    const chatForm = action.closest('.g-chatform');
    const messageId = messageElement.attr('data-id');
    const sessionToken = chatForm.attr('data-session-token');

    if (
        !messageId ||
        !sessionToken ||
        action.hasClass('is-loading') ||
        action.hasClass('is-disabled')
    ) {
        return;
    }

    action.addClass('is-loading');
    const generationRequestId = action.data('generation-request-id') || createGenerationRequestId();
    action.data('generation-request-id', generationRequestId);

    // "Continue from here" is an immediate visual branch. Detach instead of
    // deleting so a network/model failure can put the existing conversation
    // back exactly as it was. The server likewise deletes the old branch only
    // after the replacement response has been persisted.
    const discardedMessages = messageElement
        .nextAll('.g-chatform-message')
        .detach();
    const loader = appendUserMessage(chatForm, 'text');
    loader.insertAfter(messageElement).show();
    $('.g-chatform-message-actions-options').fadeOut(200);
    scrollToChatBottom(300, true);

    const restoreDiscardedMessages = () => {
        loader.remove();
        if (discardedMessages.length) {
            messageElement.after(discardedMessages);
        }
        scrollToChatBottom(300, true);
    };

    const request = {
        token: sessionToken,
        action: growtype_chat_ajax.regenerate_message_action,
        message_id: messageId,
        branch_from_here: 1,
        nonce: growtype_chat_ajax.nonce,
        generation_request_id: generationRequestId,
    };

    jQuery.ajax({
        url: growtype_chat_ajax.url,
        type: 'post',
        data: request,
        success: async function (response) {
            try {
                response = await waitForAsyncTextGeneration(response, {
                    requestStatus: requestGenerationStatus,
                });
            } catch (error) {
                restoreDiscardedMessages();
                action.removeClass('is-loading');
                handleAjaxError(error, action);
                return;
            }
            action.removeClass('is-loading');

            if (!response.success || !response.data?.response_messages) {
                action.removeData('generation-request-id');
                restoreDiscardedMessages();
                handleAjaxError(response, action);
                return;
            }

            action.removeData('generation-request-id');
            updateCredits(response.data.existing_credits);
            finishBranch(chatForm, discardedMessages, loader, response);
        },
        error: function (response) {
            restoreDiscardedMessages();
            action.removeClass('is-loading');
            handleAjaxError(response, action);
            if (Number(response.status || 0) >= 400 && Number(response.status || 0) < 500) {
                action.removeData('generation-request-id');
            }
        },
    });
}

function setEditorLoading(editor, isLoading) {
    editor.toggleClass('is-loading', isLoading);
    editor.find('textarea, button').prop('disabled', isLoading);
}

function submitEdit(saveButton, editedText) {
    const messageElement = saveButton.closest('.g-chatform-message');
    const chatForm = saveButton.closest('.g-chatform');
    const editor = saveButton.closest('.g-chatform-message-edit-form');
    const messageId = messageElement.attr('data-id');
    const sessionToken = chatForm.attr('data-session-token');

    if (!messageId || !sessionToken || editor.hasClass('is-loading')) {
        return;
    }

    setEditorLoading(editor, true);

    jQuery.ajax({
        url: growtype_chat_ajax.url,
        type: 'post',
        data: {
            token: sessionToken,
            action: growtype_chat_ajax.update_message_action,
            message_id: messageId,
            message_text: editedText,
            nonce: growtype_chat_ajax.nonce,
        },
        success: function (response) {
            if (!response.success) {
                setEditorLoading(editor, false);
                handleAjaxError(response, saveButton);
                return;
            }

            const savedText = String(response.data?.message_text || editedText);
            messageElement.attr('data-message-text', savedText);
            messageElement
                .find('.g-chatform-message-content-inner')
                .first()
                .text(savedText)
                .show();
            editor.remove();
        },
        error: function (response) {
            setEditorLoading(editor, false);
            handleAjaxError(response, saveButton);
        },
    });
}

function openMessageEditor(action) {
    const messageElement = action.closest('.g-chatform-message');
    const content = messageElement.find('.g-chatform-message-content-inner').first();
    const existingEditor = messageElement.find('.g-chatform-message-edit-form');

    if (existingEditor.length) {
        existingEditor.find('textarea').focus();
        return;
    }

    const originalText = String(messageElement.attr('data-message-text') || content.text()).trim();
    const editor = $(
        '<div class="g-chatform-message-edit-form">' +
            '<textarea class="g-chatform-message-edit-input" rows="3" aria-label="Edit message"></textarea>' +
            '<div class="g-chatform-message-edit-actions">' +
                '<button type="button" class="g-chatform-message-edit-cancel">Cancel</button>' +
                '<button type="button" class="g-chatform-message-edit-save">Save</button>' +
            '</div>' +
        '</div>'
    );

    editor.find('textarea').val(originalText);
    content.hide().after(editor);
    $('.g-chatform-message-actions-options').hide();
    editor.find('textarea').focus().select();
}

export function branchMessage() {
    $(document)
        .off('click.growtypeChatBranchEdit', '.g-chatform-message-edit')
        .on('click.growtypeChatBranchEdit', '.g-chatform-message-edit', function (event) {
            event.preventDefault();
            event.stopPropagation();
            openMessageEditor($(this));
        })
        .off('click.growtypeChatBranchCancel', '.g-chatform-message-edit-cancel')
        .on('click.growtypeChatBranchCancel', '.g-chatform-message-edit-cancel', function (event) {
            event.preventDefault();
            const messageElement = $(this).closest('.g-chatform-message');
            messageElement.find('.g-chatform-message-edit-form').remove();
            messageElement.find('.g-chatform-message-content-inner').first().show();
        })
        .off('click.growtypeChatBranchSave', '.g-chatform-message-edit-save')
        .on('click.growtypeChatBranchSave', '.g-chatform-message-edit-save', function (event) {
            event.preventDefault();
            const saveButton = $(this);
            const editedText = String(
                saveButton.closest('.g-chatform-message-edit-form').find('textarea').val() || ''
            ).trim();

            if (!editedText) {
                saveButton.closest('.g-chatform-message-edit-form').find('textarea').focus();
                return;
            }

            submitEdit(saveButton, editedText);
        })
        .off('keydown.growtypeChatBranchEditor', '.g-chatform-message-edit-input')
        .on('keydown.growtypeChatBranchEditor', '.g-chatform-message-edit-input', function (event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                $(this)
                    .closest('.g-chatform-message-edit-form')
                    .find('.g-chatform-message-edit-cancel')
                    .trigger('click');
            }

            if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
                event.preventDefault();
                $(this)
                    .closest('.g-chatform-message-edit-form')
                    .find('.g-chatform-message-edit-save')
                    .trigger('click');
            }
        })
        .off('click.growtypeChatBranchContinue', '.g-chatform-message-continue')
        .on('click.growtypeChatBranchContinue', '.g-chatform-message-continue', function (event) {
            event.preventDefault();
            event.stopPropagation();
            submitBranch($(this));
        });
}
